export { Investor, InvestorProviders, INVESTOR_INCLUDES } from './investor';
export { Unit, UnitProviders, UNIT_INCLUDES } from './unit';
export { Category, CategoryProviders } from './category';
export { Property, PropertyProviders } from './property';
export { Income, IncomeProviders } from './income';
export { Expense, ExpenseProviders } from './expense';
export { Insurance, InsuranceProviders } from './insurance';
export { Contract, ContractProviders } from './contract';
export { MonthlyCut, MonthlyCutProviders } from './monthly-cut';
export { Lessee, LesseeProviders } from './lessee';
export { UnitMonthlyCut, UnitMonthlyCutProviders } from './unit-monthly-cut';
export { InvestorMonthlyCut, InvestorMonthlyCutProviders } from './investor-monthly-cut';
export { User } from './user';
export { Config } from './config';
export { TypeUnit, TypeUnitProviders } from './type-unit';



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/index.ts